import { ErrorMessageBudle } from "../entities";

export const transformErrorMessageBundleToKeyValue = (
  errorMessageBudle: ErrorMessageBudle
): Record<string, string> => {
  const messages = errorMessageBudle.locale_data.messages;
  const result: Record<string, string> = {};

  for (const key in messages) {
    if (key === "") continue; // Skip metadata
    result[key] = messages[key][0]; // Always take the first string
  }

  return result;
};
